import axios from 'axios';

// Google Forms endpoint
const GOOGLE_FORMS_URL = 'https://docs.google.com/forms/u/0/d/e/1FAIpQLSes7sFQI6xTEANUKcBOYMYMNVPPaR0stPffjFreGilhO-ubXg/formResponse';

export interface FormSubmissionData {
    name: string;
    email: string;
    message: string;
}

const apiClient = axios.create({
    timeout: 10000, // 10 seconds timeout
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    },
});

export const submitFormViaFetch = async (formData: FormSubmissionData): Promise<{success: boolean, message: string}> => {
    try {
        // Create form data
        const formDataObj = new FormData();
        formDataObj.append('entry.1302178793', formData.name);
        formDataObj.append('entry.478720687', formData.email);
        formDataObj.append('entry.415264471', formData.message);

        await fetch(GOOGLE_FORMS_URL, {
            method: 'POST',
            mode: 'no-cors',
            body: formDataObj
        });

        return {
            success: true,
            message: 'Form submitted successfully! (No popup required)'
        };

    } catch (error) {
        return {
            success: false,
            message: 'Failed to submit form. Please try again.'
        };
    }
};

export { apiClient };
